<template>
  <div class="fill-height">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-img
            width="100%"
            height="100vh"
            alt="amanata"
            class="px-8"
            gradient="to top right, rgba(246, 225, 3, 0.25), rgba(246, 225, 3, 0.25)"
            :src="require('@/assets/background/bg_3.jpg')">
            <v-row 
              align="center" 
              justify="center"
              style="height: 100vh;">
              <v-col 
                cols="12"
                md="3">
                <v-card
                  flat
                  color="transparent">
                  <div>
                    <v-card
                      flat
                      color="#FFFFFFB2"
                      class="border-radius">
                      <v-card-text
                        class="pa-8">
                        <div
                          class="text-center mb-6">
                          <div
                            class="title font-weight-bold black--text mb-2">
                            Masuk Admin
                          </div>
                        </div>

                        <ValidationObserver 
                          ref="observer">
                          <v-form class="text-left mb-6">
                            <ValidationProvider 
                              name="Email" 
                              rules="required|email" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="save"
                                class="no_box"
                                solo
                                :color="set_color"
                                placeholder="Email"
                                prepend-inner-icon="mdi-email-outline"

                                vv-uppercase

                                v-model="form.username"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>

                            <ValidationProvider 
                              name="Password" 
                              rules="required|min:5|max:20" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="save"
                                class="no_box"
                                solo
                                :color="set_color"
                                placeholder="Password"
                                :type="show ? 'text' : 'password'"
                                prepend-inner-icon="mdi-lock-outline"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="show = !show"
                                :counter="20"

                                vv-uppercase
                                
                                v-model="form.password"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>
                          </v-form>
                        </ValidationObserver>

                        <div 
                          class="text-center mb-6">
                          <div v-if="message.error.length > 0"
                            class="text-center my-4">
                            <div
                              class="error--text d-flex align-start">
                              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                              
                              <span
                                class="ml-1">
                                {{ message.error }}
                              </span>
                            </div>
                          </div>

                          <v-btn
                            v-on:keyup.enter="save"
                            :disabled="process.form"
                            :loading="process.form"
                            @click="save"
                            block
                            x-large
                            width="170"
                            elevation="0"
                            class="title font-weight-bold white--text text-capitalize"
                            style="border-radius: 10px; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                            Masuk
                          </v-btn>
                        </div>

                        <div
                          class="body-2 text-center black--text">
                          Lupa password ?
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-img>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        await get('config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#7550e1')

              this.$store.commit("setColor", '#7550e1')
            }
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              let user = res.results.data,
                  menu = [
                    {
                      title: 'Dashboard',
                      icon: require('@/assets/icon/dashboard.png'),
                      link: '/dashboard',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Statistik',
                          icon: require('@/assets/icon/audit.png'),
                          link: '/dashboard',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Monitoring',
                          icon: require('@/assets/icon/monitor.png'),
                          link: '/monitoring',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Audit Trail',
                          icon: require('@/assets/icon/audit.png'),
                          link: '/audit',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Organisasi',
                      icon: require('@/assets/icon/struktur.png'),
                      link: '/unit',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Struktur Organisasi',
                          link: '/unit/structure',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Struktur Jabatan',
                          icon: require('@/assets/icon/posisi.png'),
                          link: '/unit/position',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Aturan Perusahaan',
                          icon: require('@/assets/icon/doc.png'),
                          link: '/unit/doc',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Pegawai',
                      icon: require('@/assets/icon/user.png'),
                      link: '/user',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Data Pegawai',
                          icon: require('@/assets/icon/user.png'),
                          link: '/user',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Presensi Pegawai',
                          icon: require('@/assets/icon/absen.png'),
                          link: '/attendance',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Lembur Pegawai',
                          icon: require('@/assets/icon/lembur.png'),
                          link: '/overtime',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Perizinan Pegawai',
                          icon: require('@/assets/icon/ijin_menu.png'),
                          link: '/permission',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Cuti Pegawai',
                          icon: require('@/assets/icon/ijin_menu.png'),
                          link: '/licensing',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Laporan Pegawai',
                          icon: require('@/assets/icon/laporan.png'),
                          link: '/report',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    {
                      title: 'Keuangan',
                      icon: require('@/assets/icon/gaji.png'),
                      link: '/salary',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Informasi Gaji',
                          link: '/salary/now',
                          active: false,
                          sub_child: [
                            {
                              title: 'Riwayat Gaji',
                              link: '/salary',
                              active: false
                            },
                            {
                              title: 'Konfigurasi Komponen',
                              link: '/salconfig',
                              active: false
                            }
                          ]
                        },
                        {
                          title: 'Reimbursement',
                          icon: require('@/assets/icon/reimburs.png'),
                          link: '/reimbursement',
                          active: false,
                          sub_child: [
                            {
                              title: 'Data Reimburse',
                              link: '/reimbursement',
                              active: false
                            },
                            {
                              title: 'Konfigurasi Komponen',
                              link: '/reimbconfig',
                              active: false
                            }
                          ]
                        }
                      ]
                    },
                    {
                      title: 'General Affair',
                      icon: require('@/assets/icon/general.png'),
                      link: '/afair',
                      active: false,
                      sub_menu: [
                        {
                          title: 'Agenda',
                          icon: require('@/assets/icon/event.png'),
                          link: '/event',
                          active: false,
                          sub_child: []
                        },
                        {
                          title: 'Pengumuman',
                          icon: require('@/assets/icon/pengumuman.png'),
                          link: '/announcement',
                          active: false,
                          sub_child: []
                        }
                      ]
                    },
                    // {
                    //   title: 'Kinerja Pegawai',
                    //   icon: require('@/assets/icon/indicator.png'),
                    //   link: '/kpi',
                    //   active: false,
                    //   sub_menu: [
                    //     {
                    //       title: 'Penilaian Pegawai',
                    //       link: '/kpi/nilai',
                    //       active: false,
                    //       sub_child: [
                    //         // {
                    //         //   title: 'Tugas Utama',
                    //         //   link: '/kpi/nilai/tugas_utama',
                    //         //   active: false
                    //         // },
                    //         // {
                    //         //   title: 'Pengembangan Diri',
                    //         //   link: '/kpi/nilai/pengembangan_diri',
                    //         //   active: false
                    //         // },
                    //         // {
                    //         //   title: 'Summary Skor',
                    //         //   link: '/kpi/nilai/summary_score',
                    //         //   active: false
                    //         // }
                    //       ]
                    //     },
                    //     {
                    //       title: 'Master Kuisoner',
                    //       link: '/kpi/master/kuisoner',
                    //       active: false,
                    //       sub_child: []
                    //     },
                    //     {
                    //       title: 'Master Kategori Penilaian',
                    //       link: '/kpi/master/category',
                    //       active: false,
                    //       sub_child: []
                    //     }
                    //   ]
                    // },
                    {
                      title: 'Perusahaan',
                      icon: require('@/assets/icon/company.png'),
                      link: '/setting/company',
                      active: false,
                      sub_menu: []
                    }
                  ]

              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu)
              )

              TokenService.saveReload(false)

              window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>